var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-column flex"},[_c('div',{staticClass:"app-email-editor",attrs:{"id":"app-email-editor"}},[_c('v-style',[_vm._v(_vm._s(_vm.styleInTag))]),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }